import { FC } from 'react'
import MuiDivider, { DividerProps as MuiDividerProps } from '@mui/material/Divider'
import Box, { BoxProps } from '@mui/material/Box'
import { SpacingProps } from '@mui/system'

export type DividerProps = SpacingProps & BoxProps

const Divider: FC<DividerProps> = (props) => (
    /**
     * <Box clone> should be desired to avoid the extra div in the markup,
     * however, it creates CSS specificity issues.
     * Alternative: Create an HR element from scratch and apply styles on top
     */
    <Box {...props}>
        <MuiDivider />
    </Box>
)

export type VerticalDividerProps = MuiDividerProps

export const VerticalDivider: FC<VerticalDividerProps> = (dividerProps) => (
    <MuiDivider orientation="vertical" flexItem {...dividerProps} />
)

export default Divider
